import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { startWith, map } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { ChangeImageComponent } from 'src/app/shared/change-image/change-image.component';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-product-general',
    templateUrl: './product-general.component.html',
    styleUrls: ['./product-general.component.scss'],
    standalone: false
})
export class ProductGeneralComponent implements OnInit {
  productGeneralForm: FormGroup;
  productId: any;
  selectable = false;
  removable = false;
  productData: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  departmentCtrl = new FormControl();
  filteredDepartments: Observable<string[]>;
  departments: any[];
  allDepartments: any[];
  ownInfoChecked = false;
  imagesList: Array<string>;
  fileList: Array<any>;

  @ViewChild('departmentInput') departmentInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  departmentsList: any[];
  invalidDepartments: boolean;
  disableInputs = true;
  userType: number;
  productName: any;
  isLoading = false;
  user: User;

  constructor(public utils: UtilsService, private dataService: DataService, private route: ActivatedRoute, private router: Router,
              private authService: AuthService,
              private dialog: MatDialog) {
                this.user = this.authService.getUserData();
                this.userType = this.authService.getUserData().type;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
                this.invalidDepartments  = false;
                this.departments = new Array<string>();
                this.allDepartments = new Array<string>();
                this.imagesList = new Array<string>();
                this.fileList = new Array();
                this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
                  startWith(null),
                  map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
  }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
        secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/general',
      });
    this.dataService.get('product/RetrieveProductById/' + this.productId).then((data) => {
      if (data.statusCode === 200) {
        this.productData = data.data;

        const date = new Date(this.productData.createdDate);

        const timeOffsetInMS = date.getTimezoneOffset() * 60000;
        date.setTime(date.getTime() - timeOffsetInMS);

        if (this.productData.departments) {
          this.productData.departments.forEach(element => {
            this.departments.push(element);
          });
        }
        this.productGeneralForm = new FormGroup({
          name: new FormControl({ value: this.productData.name, disabled: this.disableInputs }),
          description: new FormControl({ value: this.productData.description, disabled: this.disableInputs }),
          purpose: new FormControl({ value: this.productData.purpose, disabled: this.disableInputs }),
          createdDate: new FormControl( { value: date.toLocaleString(), disabled: this.disableInputs }),
        });
        this.departmentCtrl.disable();
        if (this.userType === this.utils.userTypes.Manufacturer || this.userType === this.utils.userTypes.ManufacturerChild || !this.productData.isAddedByManufacturer && this.user.type !== this.utils.userTypes.Admin) {
          this.ownInfoChecked = true;
          this.productGeneralForm.controls.name.enable();
          this.productGeneralForm.controls.name.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
          this.productGeneralForm.controls.description.enable();
          this.productGeneralForm.controls.description.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
          this.productGeneralForm.controls.purpose.enable();
          this.productGeneralForm.controls.purpose.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
          this.departmentCtrl.enable();
          this.removable = true;
          this.productGeneralForm.updateValueAndValidity();
        }

        if (this.productData.isProvideOwnInformationActive) {
          this.toggle({checked: true});
          this.ownInfoChecked = true;
        }
      }
    })
    this.productGeneralForm = new FormGroup({
      name: new FormControl({ value: null, disabled: this.disableInputs }),
      description: new FormControl({ value: null, disabled: this.disableInputs }),
      purpose: new FormControl({ value: null, disabled: this.disableInputs }),
      createdDate: new FormControl({ value: null, disabled: this.disableInputs }),
    });
    this.departmentCtrl.disable();
  }

  getProduct() {
    this.dataService.get('product/RetrieveProductById/' + this.productId).then((data) => {
      if (data.statusCode === 200) {
        this.productData = data.data;

        const date = new Date(this.productData.createdDate);

        const timeOffsetInMS = date.getTimezoneOffset() * 60000;
        date.setTime(date.getTime() - timeOffsetInMS);

        if (this.productData.departments) {
          this.productData.departments.forEach(element => {
            this.departments.push(element);
          });
        }
      }
    })
  }

  private _filter(value: any): any[] {
    return this.allDepartments.filter(department => department.name.toLowerCase().includes(value));
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.departments.includes(value.trim())) {
        this.departments.push({
          id: Math.random(),
          name: value.trim()
        });

        this.invalidDepartments = false;
      }
    }

    if (input) {
      input.value = '';
    }

    this.departmentCtrl.setValue(null);
  }

  remove(department: any, index: any): void {
    if (index >= 0) {
      this.departments.splice(index, 1);
      if (this.departments.length > 0) {
        this.invalidDepartments = false;
      } else {
        this.invalidDepartments = true;
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let departmentExist = false;
    for (let index = 0; index < this.departments.length; index++) {
      const element = this.departments[index];
      if (element.id === event.option.value.id) {
        departmentExist = true;
      }
    }
    if (!departmentExist) {
      this.departments.push(event.option.value);
    }
    this.departmentInput.nativeElement.value = '';
    this.departmentCtrl.setValue(null);
  }

  deleteProductImage(index: any, id: any) {
    if (index > -1) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Delete',
          page: 'image',
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status) {
          if (status === 'accept') {
            this.dataService.delete('product/DeleteProductPicture/' + this.productId + '/' + id).then((data) => {
              if (data.statusCode === 200) {
                this.productData.pictures.splice(index, 1);
              }
            });
          }
        }
      });
    }
  }

  spliceProductImage(index: any) {
    if (index > -1) {
      this.imagesList.splice(index, 1);
      this.fileList.splice(index, 1);
    }
  }

  addProductImage() {
    this.dialog.open(ChangeImageComponent, {
      width: '610px',
      data: { dialogParent: this, title: 'Add New Image', resizeImage: true }
    }).afterClosed().subscribe(result => {
      if (result && result.croppedImage64 !== undefined) {
        const imgSrc = result.croppedImage64;
        this.imagesList.push(imgSrc);
        this.fileList.push(result.ImageData);
      }
    });
  }

  searchDepartment(event: any) {
    if (this.departmentInput.nativeElement.value === "") {
      this.departmentsList = [];
      this.allDepartments = [];
      this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
        startWith(null),
        map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
    } else {
    this.isLoading = true;
    this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' +
    this.departmentInput.nativeElement.value, true).then((data) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          this.allDepartments = [];
          this.departmentsList = data.data.records;
          this.departmentsList.forEach((departmentData) => {
            this.allDepartments.push(departmentData);
          });
        }
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
        this.isLoading = false;
      });
    }
  }

  onImgError(event: any) {
   this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/products-dark.png'
        : '../../../assets/images/products-light.png';
    });
  }

  toggle(event: any) {
    this.ownInfoChecked = event.checked;
    if (event.checked === true) {
      this.productGeneralForm.controls.name.disable();
      this.productGeneralForm.controls.description.enable();
      this.productGeneralForm.controls.description.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
      if (this.productData.distributorDescription) {
        this.productGeneralForm.controls.description.setValue(this.productData.distributorDescription);
      } else {
        this.productGeneralForm.controls.description.setValue(this.productData.description);
      }
      this.productGeneralForm.controls.purpose.enable();
      this.productGeneralForm.controls.purpose.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
      if (this.productData.distributorPurpose) {
        this.productGeneralForm.controls.purpose.setValue(this.productData.distributorPurpose);
      } else {
        this.productGeneralForm.controls.description.setValue(this.productData.purpose);
      }

      if (this.productData.distributorDepartments?.length > 0) {
        this.departments = [];
        if (this.productData.distributorDepartments) {
          this.productData.distributorDepartments.forEach(element => {
            this.departments.push(element);
          });
        }
      } else {
        this.departments = [];
        if (this.productData.departments) {
          this.productData.departments.forEach(element => {
            this.departments.push(element);
          });
        }
      }
      this.departmentCtrl.enable();
      this.removable = true;
      this.productGeneralForm.updateValueAndValidity();
    } else {
      this.getProduct();
      this.productGeneralForm.controls.name.disable();
      this.productGeneralForm.controls.description.disable();
      this.productGeneralForm.controls.purpose.disable();
      this.productGeneralForm.controls.name.setValue(this.productData.name);
      this.productGeneralForm.controls.description.setValue(this.productData.description);
      this.productGeneralForm.controls.purpose.setValue(this.productData.purpose);
      this.departments = [];
      if (this.productData.departments) {
        this.productData.departments.forEach(element => {
          this.departments.push(element);
        });
      }
      this.departmentCtrl.disable();
      this.removable = false;
    }
  }

  deleteProduct() {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Warning',
        type: 'Warn',
        message: 'By deleting this product you will delete everything related to it, Are you sure you want to delete this product?',
        buttonText: 'cancel',
        numberOfButtons: 2,
        seconButtonText: 'Ok'
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'Ok') {
        let url = this.productData.isAddedByManufacturer ? 'ProductAccessRequest/DeleteProductAccessRequest/' : 'product/DeleteProduct/'
        this.dataService.delete(url + this.productId).then((data) => {
          if (data.statusCode === 200) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Product deleted successfully',
                buttonText: 'Ok'
              }
            });
            this.router.navigate(['/products']);
          } else if (data.statusCode === 616) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Unable to delete product because of dependency!',
                buttonText: 'Ok'
              }
            });
          } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
      }
    });
  }

  onSubmit() {
    if (this.departments.length > 0) {
    } else {
      this.invalidDepartments = true;
      return;
    }
    if (this.productGeneralForm.valid && this.departments.length > 0) {
      const departmentsIds = [];
      for (let index = 0; index < this.departments.length; index++) {
        const element = this.departments[index];
        departmentsIds.push(element.id);
      }

      if (this.ownInfoChecked && this.productData.isAddedByManufacturer) {
        const payload = {
          ProductId: parseInt(this.productId.toString(), 10),
          Description: this.productGeneralForm.get('description').value,
          Purpose: this.productGeneralForm.get('purpose').value,
          DepartmentsIds: departmentsIds,
          IsProvideOwnInformationActive: true
        };

        this.dataService.put('product/ProvideOwnInformation', payload).then((data) => {
          if (data.statusCode === 200) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Product updated successfully',
                buttonText: 'Ok'
              }
            });
          }
        })
      } else {

      this.utils.showProgressDialog();
      const payload = {
        productId: parseInt(this.productId.toString(), 10),
        name: this.productGeneralForm.get('name').value,
        description: this.productGeneralForm.get('description').value,
        purpose: this.productGeneralForm.get('purpose').value,
        departments: departmentsIds,
      };
      this.dataService.put('product/UpdateProduct', payload, true).then((data) => {
        if (data.statusCode === 200) {
          if ( this.fileList.length > 0) {
            const imagePayload = {
              productId: parseInt(this.productId.toString(), 10),
              picturePaths: this.fileList
            };
            this.dataService.put('product/UpdateProductPictures', imagePayload, true).then((mediaData) => {
              if (mediaData.statusCode === 200) {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Success',
                    type: 'Success',
                    message: 'Product updated successfully',
                    buttonText: 'Ok'
                  }
                });
                this.utils.closeProgressDialog();
                this.updateProductInfo();
              } else {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Error',
                    type: 'Error',
                    message: 'Something went wrong, Please try again!',
                    buttonText: 'Ok'
                  }
                });
                this.utils.closeProgressDialog();
              }
            });
          } else {
            this.utils.closeProgressDialog();
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Product information updated successfully',
                buttonText: 'Ok'
              }
            });
          }
        } else {
            this.utils.closeProgressDialog();
            const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });

    }
    } else if (this.productData.isAddedByManufacturer && this.ownInfoChecked === false) {
      const departmentsIds = [];
      for (let index = 0; index < this.productData.distributorDepartments.length; index++) {
        const element = this.productData.distributorDepartments[index];
        departmentsIds.push(element.id);
      }

      const ownInfoPayload = {
        ProductId: parseInt(this.productId.toString(), 10),
        Description: this.productData.distributorDescription,
        Purpose: this.productData.distributorPurpose,
        DepartmentsIds: departmentsIds,
        IsProvideOwnInformationActive: false
      };

      this.dataService.put('product/ProvideOwnInformation', ownInfoPayload).then((data) => {
        if (data.statusCode === 200) {
        }
      })
    }
  }

  updateProductInfo() {
    this.dataService.get('product/RetrieveProductById/' + this.productId).then((data) => {
      if (data.statusCode === 200) {
        this.imagesList = [];
        this.fileList = [];
        this.departments = [];
        this.productData = data.data;
        if (this.productData.departments) {
          this.productData.departments.forEach(element => {
            this.departments.push(element);
          });
        }
      }
    });
  }

}
